import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Row, Col } from "react-bootstrap";
import { find } from "lodash";

import * as projectActions from "../../actions/projectActions";
import * as contactActions from "../../actions/contactActions";
import * as modalActions from "../../actions/modalActions";

import ProjectAttachmentList from "./ProjectAttachmentList";
import Searchbar from "../common/Searchbar";
import BreadCrumbs from "../common/BreadCrumbs";
import FileUpload from "../common/FileUpload";
import ConfirmModal from "../common/ConfirmModal";
import { customToast as toast } from "../../utils";

class ProjectAttachmentsPage extends Component {
  constructor(props) {
    super(props);
    this.state = { search: "", loading: false };
  }

  componentDidMount = async () => {
    const { actions } = this.props;
    await actions.getProject(this.props.match.params.id);
  };

  onClickDelete = (projectAttachmentId) => {
    this.props.actions.requestAttachmentId(projectAttachmentId);
  };

  onClickDownload = (file) => {
    const fileToDownload = find(this.props.project.attachments, { id: file });
    this.props.actions.downloadFile(this.props.project, fileToDownload);
  };

  handleDelete = async () => {
    const { project } = this.props;
    const attachment = { id: this.props.projectAttachmentToDelete };

    await this.props.actions.deleteAttachment(project, attachment);
    await this.props.actions.getProject(project.id);
  };

  uploadFile = async (files) => {
    const invalidFileNames = files.find((file) => file.name.length > 255);
    if (invalidFileNames) {
      toast.error("The name of the file is too long");
    } else {
      await this.props.actions.uploadFile(this.props.project, files);
      await this.props.actions.getProject(this.props.project.id);
    }
  };

  handleCancel = () => {
    this.props.actions.hideModal();
  };

  filter = (e) => {
    this.setState({ search: e.target.value });
  };

  render() {
    const { project, isMobile, auth } = this.props;
    const { loading } = this.state;
    return (
      <div>
        <Row className="header-wrapper">
          <BreadCrumbs
            breadcrumbs={[{ label: project.name }, { label: "Attachments" }]}
          />
          <Col md={5} xs={12} className="flex">
            <Searchbar onFilter={this.filter} />
          </Col>
        </Row>
        <Row>
          <FileUpload auth={auth} onDrop={this.uploadFile} disabled={loading} />
        </Row>
        <div className="content-wrapper transparent">
          <ProjectAttachmentList
            project={project}
            search={this.state.search}
            isMobile={isMobile}
            onClickDownload={this.onClickDownload}
            onClickDelete={this.onClickDelete}
          />
          <ConfirmModal
            id="attachmentDeleteModal"
            title="Delete Attachment"
            body="Are you sure you want to delete this attachment?"
            close={this.props.actions.hideModal}
            confirm={this.handleDelete}
          />
        </div>
      </div>
    );
  }
}

ProjectAttachmentsPage.propTypes = {
  actions: PropTypes.object.isRequired,
  project: PropTypes.object,
  projectAttachmentToDelete: PropTypes.object,
  match: PropTypes.object,
  params: PropTypes.object,
  isMobile: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    project: state.reducers.project,
    projectAttachmentToDelete: state.reducers.projectAttachmentToDelete
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...projectActions,
        ...contactActions,
        ...modalActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(ProjectAttachmentsPage);
